import { Header } from './Header';
import { Button } from './Button';
import { Loader } from './Loader';
import { Container } from './Container';
import { Modal } from './Modal'


export const components = {

  Header,
  Button,
  Loader,
  Container,
  Modal


};
